import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ResponseData } from '../models/response';
import { feedback, feedbackResponse } from '../models/feedbackResponse';
import { environment } from '../../environments/environment';
import { ProductQnaResponseData } from '../models/product-qa-chat';
import { config, navbarOption, userConfig } from '../models/config';
import { currentChatState, ImageUrls } from '../models/chat';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  // api url key
  url:string = environment.apiUrl;
  // delete boolean flag
  deleteFlag = new BehaviorSubject(false);
  // navbar options
  navbarOptions = new BehaviorSubject<navbarOption>({
    states: [],
    stores: []
  })
  // chat subscription for unsubscribing chat subscription
  chatSubscription!: Subscription;
  // delete subscription for unsubscribing delete flag
  deleteSubscription!: Subscription;
  // search subscription for unsubscribing search subscription
  searchSubscription!: Subscription;
  // compare subscription for checking the compare flag
  compareSubscription!:Subscription;
  // navbar options subscription
  navbarOptionsSubscription!: Subscription;
  // show product panel flag in mobile view
  showPanel = new BehaviorSubject<boolean>(false);
  // panel check flag to check if the flag is true or false
  panelCheckFlag = false;
  // user object
  userObj:userConfig = {
    sub: '',
    empid: '',
    name: '',
    memberof: [],
    family_name: '',
    email: '',
    samaccountname: '',
    user_id: ''
  };
  // existing chat
  currentChat:currentChatState  = {
    sessionId: '',
    chat: []
  };
  // current route
  currentRoute = '';
  // compare status flag
  compareStatus = new BehaviorSubject<boolean>(true);
  // compare product select flag
  compareSelectFlag = new BehaviorSubject<boolean>(false);
  // current bot value
  currentBot = '';
  
  constructor(private http:HttpClient) { }

  setDeleteFlag(flag:boolean){
    this.deleteFlag.next(flag);
  }

  setNavbarOptions(option: navbarOption){
    this.navbarOptions.next(option);
  }

  setPanelInformation(option:boolean){
    this.showPanel.next(option);
  }

  setCheckFlag(option:boolean){
    this.panelCheckFlag = option;
  }

  setUserInfo(userObj:userConfig){
    this.userObj = userObj;
  }
  
  setCurrentRouteInfo(route:string){
    this.currentRoute = route;
  }

  getCurrentRouteInfo(){
    return this.currentRoute;
  }

  setCompareStatus(flag:boolean){
    this.compareStatus.next(flag);
  }

  setCompareSelectFlag(flag:boolean){
    this.compareSelectFlag.next(flag);
  }

  set currentBotValue(name:string){
    this.currentBot = name;
  }

  get currentBotValue(){
    return this.currentBot;
  }

  get userInfo(){
    return this.userObj;
  }

  get currentStateOfChat(){
    return this.currentChat;
  }

  set currentStateOfChat(currentChat:currentChatState){
    this.currentChat = currentChat;
  }

  askScotty(message:string, sessionId: string, storeName:string | undefined, stateName:string | undefined, intialization:boolean, user: userConfig):Observable<ResponseData>{
    const body = {
      text: message,
      sessionId: sessionId,
      store: storeName,
      state: stateName,
      init: intialization,
      user: user
    }
    return this.http.post<ResponseData>(`${this.url}/ask-scotty`,body)
  }

  productQnAandComparison(message:string | undefined, intialization:boolean,parentSessionId:string, childSessionId:string, user: userConfig, type:string, store:string | undefined, state:string | undefined, source:string):Observable<ProductQnaResponseData>{
    let url = '';
    let text ;
    // if intialization is true and type is comparison then send the ids in array format 
    if(intialization && type === 'comparison'){
      text = message?.split(',');
    } else {
      text = message
    }

    const body = {
      sourceInfo : source,
      text: text,
      init: intialization,
      parentSessionId: parentSessionId,
      childSessionId: childSessionId,
      user: user,
      configs: {
        store: store,
        state: state
      }
    }
    if(type === 'qna'){
      url = `${this.url}/ask-scotty/product-qna`;
    } else {
      url = `${this.url}/ask-scotty/product-comparison`;
    }
    return this.http.post<ProductQnaResponseData>(url, body);
  }

  feedback(responseId:string, sessionId:string, feedback: string, feedbackReason?: string, feedbackReasonText?: string):Observable<feedback>{
    const body:feedbackResponse = {
      responseId: responseId,
      sessionId: sessionId,
      feedback: feedback,
    };
    if(feedbackReason || feedbackReasonText){
      body['feedbackReason'] = feedbackReason;
      body['feedbackReasonText'] = feedbackReasonText;
    }
    return this.http.post<feedback>(`${this.url}/ask-scotty/feedback`,body)
  }

  getSignedImages(key:string, imageCategory:string):Observable<ImageUrls>{
    const body = {
      key: key,
      image_category: imageCategory
    };
    return this.http.post<ImageUrls>(`${this.url}/ask-scotty/signed-images`, body);
  }

  getConfigs():Observable<config>{
    return this.http.get<config>(`${this.url}/ask-scotty/config`);
  }
  
}
